module.exports = __webpack_public_path__ + "static/img/mb-gt-amg-land-big.9d9a14d2.jpg";